export var ZIPCODE_REGEX = /^\d{5}$/;
export var NON_DIGITS_REGEX = /[^\d]+/g;
export var PO_BOX_ADDRESS_REGEX = /\b(P(OST)?\.?\s*(O(FF(ICE)?)?)?\.?\s*B(IN\b|OX\b|\.?))/i;
export var NAME_REGEX = /^[a-zA-Z '-]*$/;
export var PHONE_REGEX = /(\d{3})-?(\d{3})-?(\d{4})/;
export var COMPANY_NAME_REGEX = /^[a-zA-Z.*#().;@/&0-9' ]+$/;
export var ADDRESS_REGEX = /^[a-zA-Z\d\-_.,!@#$%^()+=? "'\\ :\s]+$/;
export var NUMBERS_REGEX_GLOBAL = /^[0-9]*$/g;
export var BASE64_ENCODED_REGEX = /^(?:[A-Za-z\d+/]{4})*(?:[A-Za-z\d+/]{3}=|[A-Za-z\d+/]{2}==)?$/;
export var NUMBERS_REGEX = /^[0-9]+$/;
export var CARD_HOLDER_NAME_REGEX = /^[A-Za-z_\-. ]*$/i;
export var BILLING_ADDRESS_REGEX = /^[A-Za-z0-9.&$\- ]*$/i;
export var CARD_NICKNAME_REGEX = /^[A-Za-z0-9_&\-#.'’ ]*$/;
export var NICKNAME_REGEX = /^[a-zA-Z0-9.#_&\- ]*$/;
export var CHECKING_ACCOUNT_ROUTING_REGEX = /^\d{9}$/;
export var KEYTAG_NUMBER_REGEX = /(\d{4})-?(\d{4})-?(\d{4})-?(\d{4})/;
